/**
 * Sanityzacja tekstu do zapisu w Firmatic (ISO-8859-2 / Latin-2).
 *
 * Firmatic przyjmuje polskie znaki, ale typograficzne znaki spoza Latin-2
 * (smart quotes, em-dash, niełamliwe spacje itd.) zamieniają się w krzaki.
 * Transliterujemy znane odpowiedniki, resztę spoza ISO-8859-2 zastępujemy '?'.
 * Brama (unigateway) przekodowuje parametry do ISO-8859-2 i na znaku spoza
 * zestawu (emoji, „…") zwraca 500 — dlatego api.client czyści nim KAŻDY
 * parametr tekstowy (zgłoszenie ForClever 2026-10-21, opis sprawy 4006).
 * Mapa budowana z kodów (nie literałów), żeby nie pomylić podobnych znaków.
 */
const TRANSLIT_CODES: Array<[number, string]> = [
  [0x2014, '-'], [0x2013, '-'], [0x2212, '-'], [0x2011, '-'],
  [0x2264, '<='], [0x2265, '>='],
  [0x2026, '...'],
  [0x201e, '"'], [0x201c, '"'], [0x201d, '"'], [0x00ab, '"'], [0x00bb, '"'],
  [0x2018, "'"], [0x2019, "'"], [0x201a, ','],
  [0x2022, '*'], [0x00b7, '.'],
  [0x00a0, ' '], [0x202f, ' '], [0x2009, ' '], [0x2007, ' '],
  [0x2192, '->'], [0x2190, '<-'],
  [0x00d7, 'x'],
];

const translit: Record<string, string> = {};
for (const [code, rep] of TRANSLIT_CODES) translit[String.fromCharCode(code)] = rep;

/** Górna połowa ISO-8859-2 (0xA0-0xFF): polskie litery, ale też ü, é, ß, ö... */
const LATIN2_HIGH = (() => {
  try {
    return new TextDecoder('iso-8859-2').decode(Uint8Array.from({ length: 96 }, (_, i) => 0xa0 + i));
  } catch {
    return 'ąĄćĆęĘłŁńŃóÓśŚźŹżŻ';
  }
})();

export function sanitizeForLatin2(s: string): string {
  let out = '';
  for (const ch of s) {
    if (translit[ch] !== undefined) { out += translit[ch]; continue; }
    const code = ch.charCodeAt(0);
    if (code === 9 || code === 10 || code === 13 || (code >= 0x20 && code <= 0x7e)) { out += ch; continue; }
    if (LATIN2_HIGH.includes(ch)) { out += ch; continue; }
    out += '?';
  }
  return out;
}
